// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-div {
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}

.services {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 6rem;
}

.service-container {
    padding: 2rem;
}

.portofolio {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 6rem;
    text-align: center;
}


.portofolio-works {
    display: flex;
}

.portofolio-works-image {
    list-style-type: none;  
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    overflow: hidden;

    & li {
        flex-grow: 1;
    }
}

.league-spartan-title {
    font-family: "League Spartan", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  text-align: center;
}

.avatar {
    width: 100px;
    margin-bottom: 20px;

}

.avatar-text {
    width: 30%;
    line-height: 2.5rem;
    margin-bottom: 2rem;
}

.portofolio-carousel {
    margin-top: 10px;
    position: relative;
}

.portofolio-image {
    height: 350px;
    margin-right: 20px;
}

.view-more {
    height: 100px;
    width: 100px;
    border-radius: 50%;
    border: 10px solid #FF8D8D;
    background-color: #FD7272;
    position: absolute;
    right: -50px;
    top: 40%;
}

.service-short-description {
    color: #545454;
    text-align: justify;
}

@media screen and (max-width: 500px) {
    .avatar-text {
        width: 100%;
    }
}

@media screen and (max-width: 1200px) {
    .view-more {
        height: 50px;
        width: 100px;
        background-color: #FD7272;
        border: none;
        border-radius: 30px;
        position: absolute;
        right: 40%;
        top: 100%
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;;IAEhB;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oCAAoC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;QACV;IACJ;AACJ","sourcesContent":[".main-div {\n    height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    text-align: center;\n}\n\n.services {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-bottom: 6rem;\n}\n\n.service-container {\n    padding: 2rem;\n}\n\n.portofolio {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    margin-bottom: 6rem;\n    text-align: center;\n}\n\n\n.portofolio-works {\n    display: flex;\n}\n\n.portofolio-works-image {\n    list-style-type: none;  \n    display: flex;\n    flex-direction: row;\n    flex-grow: 1;\n    overflow: hidden;\n\n    & li {\n        flex-grow: 1;\n    }\n}\n\n.league-spartan-title {\n    font-family: \"League Spartan\", serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  text-align: center;\n}\n\n.avatar {\n    width: 100px;\n    margin-bottom: 20px;\n\n}\n\n.avatar-text {\n    width: 30%;\n    line-height: 2.5rem;\n    margin-bottom: 2rem;\n}\n\n.portofolio-carousel {\n    margin-top: 10px;\n    position: relative;\n}\n\n.portofolio-image {\n    height: 350px;\n    margin-right: 20px;\n}\n\n.view-more {\n    height: 100px;\n    width: 100px;\n    border-radius: 50%;\n    border: 10px solid #FF8D8D;\n    background-color: #FD7272;\n    position: absolute;\n    right: -50px;\n    top: 40%;\n}\n\n.service-short-description {\n    color: #545454;\n    text-align: justify;\n}\n\n@media screen and (max-width: 500px) {\n    .avatar-text {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .view-more {\n        height: 50px;\n        width: 100px;\n        background-color: #FD7272;\n        border: none;\n        border-radius: 30px;\n        position: absolute;\n        right: 40%;\n        top: 100%\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
